import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { type ILead, type ILeadLink, leadLinksManager } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { isDataObject } from '@/services/data-object-helper';

import { LEAD_MODULE } from '../lead-module';

export const DELETE_LINK = 'deleteLink';

export const actions: ActionTree<ILeadLink, unknown> = {
    /**
     * Unused since 4139
     */
    async [DELETE_LINK](context, { idList }: { idList: number[] }): Promise<void> {
        await leadLinksManager.deleteLink({ ids: idList.join() });
        for (const dobjId of idList) {
            context.commit(REMOVE_DATA_OBJECTS, { dobjId });
        }
    },

    [STORE_DATA_OBJECTS](context, { dataObjectList }: { dataObjectList: ILeadLink[] }) {
        const leadLinks: ILeadLink[] = [];
        const leads: ILead[] = [];

        dataObjectList.forEach((link) => {
            let _link = Object.assign({}, link);

            // Extract leads objects if necessary
            if (isDataObject<ILead>(link.fromLead)) {
                const fromLead = Object.assign({}, link.fromLead);
                _link = Object.assign({}, _link, { fromLead: fromLead.dobjId });
                leads.push(fromLead);
            }

            if (isDataObject<ILead>(link.toLead)) {
                const toLead = Object.assign({}, link.toLead);
                _link = Object.assign({}, _link, { toLead: toLead.dobjId });
                leads.push(toLead);
            }

            leadLinks.push(_link);
        });

        if (leads.length > 0) {
            void context.dispatch(`${LEAD_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: leads }, { root: true });
        }
        if (leadLinks.length > 0) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: leadLinks });
        }
    }
};
